import type { ReactNode } from 'react';
import { colors } from '../lib/theme';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

interface Props {
  dates: string[];
  selectedDate: string;
  todayDate: string;
  onSelect: (date: string) => void;
  after?: ReactNode;
}

export default function DaySelector({ dates, selectedDate, todayDate, onSelect, after }: Props) {
  return (
    <nav style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.5rem' }}>
      {dates.map((date) => {
        const isSelected = date === selectedDate;
        const isToday = date === todayDate;
        const [, , day] = date.split('-');
        const weekday = WEEKDAY_LABELS[new Date(date).getUTCDay()];

        return (
          <button
            key={date}
            onClick={() => onSelect(date)}
            style={{
              position: 'relative',
              width: 56,
              height: 56,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 14,
              border: 'none',
              background: isSelected ? colors.pink : colors.lavender,
              color: isSelected ? '#fff' : colors.lavenderText,
              fontWeight: isSelected ? 700 : 600,
              cursor: 'pointer',
            }}
          >
            {isToday && (
              <span
                style={{
                  position: 'absolute',
                  top: 6,
                  right: 6,
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: isSelected ? '#fff' : colors.pink,
                }}
              />
            )}
            <span style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>{weekday}</span>
            <span style={{ fontSize: '1rem' }}>{day}</span>
          </button>
        );
      })}
      {after}
    </nav>
  );
}
